import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]

  toggle(event) {
    const clickedItem = event.currentTarget.closest("[data-faq-accordion-target='item']")
    const answer = clickedItem.querySelector("[data-faq-answer]")
    const chevron = clickedItem.querySelector("[data-faq-chevron]")
    const isOpen = answer.style.display !== "none"

    // Close all
    this.itemTargets.forEach(item => {
      const a = item.querySelector("[data-faq-answer]")
      const c = item.querySelector("[data-faq-chevron]")
      if (a) a.style.display = "none"
      if (c) c.style.transform = "rotate(0deg)"
    })

    // Toggle clicked
    if (!isOpen) {
      answer.style.display = "block"
      if (chevron) chevron.style.transform = "rotate(180deg)"
    }
  }
}
